import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { cn } from '@/lib/utils';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { FabricDialog } from '../../ProductOptions/fabric-dialog';
import type { SwatchDataValue } from '../types/data';
import type { ProductRoot } from '../types/product';
import { useGetInstockFabricOptions } from './use-get-instock-fabric-options';

type FabricOptionProps = {
  item: {
    uid: string;
    label: string;
    values: SwatchDataValue[];
  };
  createFabricButton?: React.ReactNode;
  handleClick: any;
  clickIndex: number;
  optionSpecs: any;
  product: ProductRoot;
};

export const FabricOptions = ({
  item,
  createFabricButton,
  handleClick,
  clickIndex,
  optionSpecs,
  product,
}: FabricOptionProps) => {
  const form = useFormContext();
  const { watch, control } = form;

  const { field: fieldSize } = useController({
    name: 'Size',
    control,
  });

  const { field: fieldColor } = useController({
    name: 'Color',
    control,
  });

  const allFormData = watch();

  const { values } = useGetInstockFabricOptions({
    product,
    oldValues: item?.values,
  });

  return (
    <FormField
      key={item.uid}
      control={form.control}
      name={item.label}
      render={({ field }) => (
        <FormItem
          suppressHydrationWarning
          className='space-y-2.5 bg-white  px-2.5  py-[15px] lg_p-0 lg_px-0'
        >
          <FormLabel className='option_title__x4i8y text-colorDefault flex items-center gap-x-[5px] '>
            <span className='text-base uppercase leading-5'>{item.label}: </span>
            <span className='text-[15px] leading-5'>{allFormData[item.label]?.label.replace('-default', '')}</span>
          </FormLabel>
          <FormMessage id={item.label} />
          <FormControl suppressHydrationWarning>
            <RadioGroup
              suppressHydrationWarning
              onValueChange={value => {
                const selectedOption = values.find(v => v.value_index.toString() === value);

                if (selectedOption) {
                  field.onChange({
                    value_index: value,
                    label: selectedOption?.label,
                    price: selectedOption?.price,
                    option_id: selectedOption?.option_id?.toString() || item?.attribute_id,
                  });
                  form.resetField('Color');
                  form.resetField('Size');
                }

                const couldSelect = optionSpecs.includes(value);

                // 布料永远加入顶点
                handleClick({
                  bool: true,
                  text: value,
                  index: clickIndex,
                  isFabric: true,
                });

                // fieldSize.onChange(undefined);

                // fieldColor.onChange(undefined);
              }}
              value={field.value?.value_index}
              className='flex flex-wrap gap-2.5'
            >
              {values.map(option => (
                <FabricRadioItem
                  key={option.uid}
                  item={option}
                  optionSpecs={optionSpecs}
                />
              ))}
              {createFabricButton}
            </RadioGroup>
          </FormControl>

          <FabricDialog />
        </FormItem>
      )}
    />
  );
};

const FabricRadioItem = ({ item, optionSpecs }: { item: SwatchDataValue; optionSpecs: any }) => {
  const inStock = optionSpecs.includes(item.value_index.toString());

  // const isOutOfStock = outOfStockVariants.flat().includes(item.value_index);
  const isOutOfStock = !inStock;

  return (
    <FormItem
      suppressHydrationWarning
      className='flex max-w-[150px] flex-1 items-center space-y-0'
    >
      <FormControl suppressHydrationWarning>
        <RadioGroupItem
          value={item.value_index.toString()}
          className='peer sr-only'
          suppressHydrationWarning
        />
      </FormControl>
      <FormLabel
        suppressHydrationWarning
        className={cn(
          'tile_root__gozBD flex min-h-[36px] w-full flex-1 cursor-pointer items-center justify-center  rounded-[3px] border-1 border-solid border-80583F bg-f8f3ef px-1 text-80583F peer-data-[state=checked]_bg-primary peer-data-[state=checked]_text-white  [&:has([data-state=checked])]_text-white ',
          // isOutOfStock && "opacity-50"
        )}
      >
        {item.label.replace('-default', '')}
      </FormLabel>
    </FormItem>
  );
};
